import reactToWebComponent from "@r2wc/react-to-web-component"
import FormPopup from "../FormPopup/FormPopup"

const FormPopupElement = reactToWebComponent(FormPopup, {
  props: {
    hubspotPortalId: "string",
    hubspotFormId: "string",
    formType: "string",
    emailProperty: "string",
    firstNameProperty: "string",
    phoneProperty: "string",
    stateProperty: "string",
    additionalPropertyName: "string",
    additionalPropertyValue: "string",
    consentToProcessText: "string",
    communicationConsents: "string",
    formTitle: "string",
    formSubtitle: "string",
    states: "string",
    submitButtonText: "string",
    emailPlaceholder: "string",
    firstNamePlaceholder: "string",
    phonePlaceholder: "string",
    stateLabel: "string",
    confirmationTitle: "string",
    confirmationMessage: "string",
    confirmationButtonText: "string",
    confirmationButtonUrl: "string",
    recaptchaText: "string",
    recaptchaSiteKey: "string",
    backgroundColor: "string",
    overlayColor: "string",
    textColor: "string",
    buttonColor: "string",
    buttonTextColor: "string",
    buttonHoverColor: "string",
    buttonHoverTextColor: "string",
    fontFamily: "string",
    headingFontFamily: "string",
    waitForAgeGate: "string",
    waitForStorageKey: "string",
    waitForStorageValue: "string",
    waitUntilHidden: "string",
    waitUntilHiddenHost: "string",
  },
  shadow: "open",
})

/** Registers `<form-popup>` once. Safe to call multiple times. */
export function registerFormPopupElement(): void {
  if (typeof customElements === "undefined") return
  if (!customElements.get("form-popup")) {
    customElements.define("form-popup", FormPopupElement)
  }
}

registerFormPopupElement()

export default FormPopupElement
